export const uk = {
    'new-banner': 'Новое объявление'
};
